module.exports = "<div class=\"purchase-orders\"><ui-view></ui-view></div>";